import { render, staticRenderFns } from "./ModulePageComponent.vue?vue&type=template&id=3b7bf224"
import script from "./ModulePageComponent.vue?vue&type=script&lang=js"
export * from "./ModulePageComponent.vue?vue&type=script&lang=js"
import style0 from "./ModulePageComponent.vue?vue&type=style&index=0&id=3b7bf224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports